import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';
import RouterUtils from '../../../../../shared/routing/RouterUtils';

export class WorkerDetailRequest {

    _id; // number

    constructor() {
        this._id = -1;
    }

    setId(id) {
        this._id = id;
    }

    route() {
        return RouterUtils.generateRoute(ApiEndpoints.WORKER_ID, { id: this._id });
    }

}



// WEBPACK FOOTER //
// ./src/app/my-outsources/worker/form/update/worker-detail/WorkerDetailRequest.js